{
  "version": 1,
  "asset_id": "33ccbb8a-29c5-481d-a311-006ec30b45be",
  "project_id": "4e628cc3-9baa-4a87-b23b-02ac04e85c33",
  "url": "/__l5e/assets-v1/33ccbb8a-29c5-481d-a311-006ec30b45be/resultado_6.png",
  "r2_key": "a/v1/4e628cc3-9baa-4a87-b23b-02ac04e85c33/33ccbb8a-29c5-481d-a311-006ec30b45be/resultado_6.png",
  "original_filename": "resultado_6.png",
  "size": 1126029,
  "content_type": "image/png",
  "created_at": "2026-07-07T11:53:22Z"
}
